import { Component,
         Output,
         EventEmitter,
         OnInit,
         ViewChild}                   from '@angular/core';
import { MatDialogRef, MatSort }             from '@angular/material';
import { Observable }               from 'rxjs/Observable';
import { SortableFilter }           from './../common/sortable-filter';
import { PeakService }              from './../shared/peak.service';
import { Globals }                  from './../common/globals';
import { BusModel }                 from './../bus-list/bus.model';
import { BusService }               from '../shared/bus.service';
import { MatDialog }                from '@angular/material';
import { SavingDialogComponent }    from './../common/saving-dialog.component';
import { UserService }              from '../shared/user.service';
import { TableColumn,
         TableColumnType }          from './../common/table-column';
import { UserSortableFilter }       from './../user-list/user-sortable-filter';
import { MatSnackBar }              from '@angular/material';
import { CdkTableModule }           from '@angular/cdk/table';
import { DataSource }               from '@angular/cdk/table';
import * as moment                  from 'moment';
import { CollectionViewer }         from '@angular/cdk/collections';
import { isPending }                from 'q';
import { FormControl }              from '@angular/forms';
import { startWith }                from 'rxjs/operators/startWith';
import { map }                      from 'rxjs/operators/map';

@Component({
  selector: 'sa-bus-dialog',
  template: require('./bus-dialog.component.html'),
  styles: [require('./bus-dialog.component.scss')]
})
export class BusDialogComponent implements OnInit {

  public newItem = false;
  public model = new BusModel();
  public memberDelete = -1;
  public selectedMember: any;
  public accessDelete = -1;
  public selectedAccess: any;
  private errors = [];
  private dataReady = false;
  private driversForCrew: any[];
  private driversForTempCrew: any[];
  private driversForAccess: any[];

  private crewMembersAutoComplete: Observable<any>;
  private tempCrewMembersAutoComplete: Observable<any>;
  private accessesAutoComplete: Observable<any>;

  private crewStateCtrl: FormControl;
  private tempCrewStateCtrl: FormControl;
  private accessStateCtrl: FormControl;

  private newCrewMember: CrewMember;
  private newTempCrewMember: CrewMember;
  private newAccess: OneDayAccess;

  private newDate: Date = new Date();

  private exportTime = {hour: 12, minute: 0, meriden: 'AM'};

  private tempId = 0;

  itemsDataSource: ItemDataSource;
  tempCrewDataSource: ItemDataSource;
  accessDataSource: AccessDataSource;
  itemsColumns = ['firstName', 'lastName', 'userNumber', 'isPrimary', 'custom'];
  accessColumns = ['firstName', 'lastName', 'userNumber', 'dateCreated', 'custom'];
  @ViewChild(MatSort) itemsSort: MatSort;


  constructor(
    public dialogRef: MatDialogRef<BusDialogComponent>,
    busService: BusService,
    public globals: Globals,
    private userService: UserService,
    private dialog: MatDialog
    // private busCrewService: BusCrewService,
    // private oneDayAccessService: OneDayAccessService
  ) {
    this.crewStateCtrl = new FormControl();
    this.crewMembersAutoComplete = this.crewStateCtrl.valueChanges
      .pipe(
        map(state => state ? this.filterDriversForCrew(state) : this.driversForCrew)
      );

    this.tempCrewStateCtrl = new FormControl();
    this.tempCrewMembersAutoComplete = this.tempCrewStateCtrl.valueChanges
      .pipe(
        map(state => state ? this.filterDriversForTempCrew(state) : this.driversForTempCrew)
      )

    this.accessStateCtrl = new FormControl();
    this.accessesAutoComplete = this.accessStateCtrl.valueChanges
      .pipe(
        map(state => state ? this.filterDriversForAccess(state) : this.driversForAccess)
      );
  }

  private autoCrewDisplayFn(user: CrewMember) {
    if (!user) { return ''; }
    return user.firstName + ' ' + user.lastName + ' - ' + user.userNumber;
  }

  private autoAccessDisplayFn(access: OneDayAccess) {
    if (!access) { return ''; }
    return access.firstName + ' ' + access.lastName + ' - ' + access.userNumber;
  }

  public delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?\nTato změna je nevratná.')) {
      this.dialogRef.close('delete');
    }
  }

  public close() {
    if (confirm('Opravdu si přejete zavřít tento dialog?\nNeuložené změny budou ztraceny.')) {
      this.dialogRef.close('cancel');
    }
  }

  public save() {
    this.errors = [];
    if (isNaN(this.model.busNumber)) {
        this.errors.push('Zadejte prosím číslo autobusu');
    }
    if (!this.model.regPlate || this.model.regPlate.length === 0) {
        this.errors.push('Zadejte prosím SPZ autobusu');
    }
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }

  public addCrewMember(isPrimary = false) {
        if ((typeof this.newCrewMember === 'string') || (typeof this.newCrewMember === 'undefined') || this.newCrewMember === null) {
          return;
        }

        if (isPrimary) {
          if (this.model.crewMembers.find(x => x.isPrimary === true && x.crewType === 1)) {
            if (!confirm('V autobuse již je hlavní řidič.')) { return; }
          }
          if (this.model.allPrimaryBusDrivers.find(x => x.userNumber === this.newCrewMember.userNumber)) {
            if (!confirm('Tento řidič je jako hlavní v jiném autobuse.')) { return; }
          }
        }

        this.newCrewMember.isPrimary = isPrimary;
        this.newCrewMember.crewType = 1;
        this.model.crewMembers.push(this.newCrewMember);

        let index = this.driversForCrew.findIndex(e => e.userNumber === this.newCrewMember.userNumber);
        this.driversForCrew.splice(index, 1);

        this.itemsDataSource = new ItemDataSource(this.model.crewMembers.filter(c => c.crewType === 1), new MatSort());
        this.newCrewMember = null;
        this.crewStateCtrl.updateValueAndValidity();
  }

  public removeCrewMember(userNumber) {

        let index = this.model.crewMembers.findIndex(e => e.userNumber === userNumber && e.crewType === 1);
        this.driversForCrew.push(this.model.crewMembers.find(e => e.userNumber === userNumber && e.crewType === 1));
        this.model.crewMembers.splice(index, 1);
        this.itemsDataSource = new ItemDataSource(this.model.crewMembers.filter(c => c.crewType === 1), new MatSort());

  }

  public addTempCrewMember(isPrimary = false) {
    if ((typeof this.newTempCrewMember === 'string') ||
        (typeof this.newTempCrewMember === 'undefined') ||
        this.newTempCrewMember === null) {
      return;
    }

    if (isPrimary) {
      if (this.model.crewMembers.find(x => x.isPrimary === true && x.crewType === 2)) {
        if (!confirm('V autobuse již je hlavní řidič.')) { return; }
      }

      if (this.model.allPrimaryBusDrivers.find(x => x.userNumber === this.newTempCrewMember.userNumber)) {
        if (!confirm('Tento řidič je jako hlavní v jiném autobuse.')) { return; }
      }
    }

    this.newTempCrewMember.isPrimary = isPrimary;
    this.newTempCrewMember.crewType = 2;
    this.model.crewMembers.push(this.newTempCrewMember);

    let index = this.driversForTempCrew.findIndex(e => e.userNumber === this.newTempCrewMember.userNumber);
    this.driversForTempCrew.splice(index, 1);

    this.tempCrewDataSource = new ItemDataSource(this.model.crewMembers.filter(c => c.crewType === 2), new MatSort());
    this.newTempCrewMember = null;
    this.tempCrewStateCtrl.updateValueAndValidity();
}

public removeTempCrewMember(userNumber) {
    let index = this.model.crewMembers.findIndex(e => e.userNumber === userNumber && e.crewType === 2);
    this.driversForTempCrew.push(this.model.crewMembers.find(e => e.userNumber === userNumber && e.crewType === 2));
    this.model.crewMembers.splice(index, 1);
    this.tempCrewDataSource = new ItemDataSource(this.model.crewMembers.filter(c => c.crewType === 2), new MatSort());
}

  public addOneDayAccess(access, date) {
    if ((typeof access === 'string') || (typeof access === 'undefined') || access === null) {
      return;
    }
    date.setHours((this.exportTime.meriden === 'PM' ? (this.exportTime.hour + 12) : this.exportTime.hour), this.exportTime.minute, 0);

    this.model.oneDayAccesses.push({
      id: this.tempId++,
      firstName: access.firstName,
      lastName: access.lastName,
      userNumber: access.userNumber,
      dateCreated: new Date(date)
    });
    this.accessDataSource = new AccessDataSource(this.model.oneDayAccesses, new MatSort());
    this.newAccess = null;
  }

  public removeOneDayAccess(id) {

    let index = this.model.oneDayAccesses.findIndex(e => e.id === id);
    this.model.oneDayAccesses.splice(index, 1);
    this.accessDataSource = new AccessDataSource(this.model.oneDayAccesses, new MatSort());
  }

  public formatDate(d: Date) {
    return moment(d).format('DD.MM.YYYY, HH:mm');
  }

  filterDriversForCrew(input) {

    // this.filterByCrewMembres();

    if (typeof input !== 'string') {
      return this.driversForCrew;
    }

    return this.driversForCrew.filter(driver =>
      driver.userNumber.toLowerCase().indexOf(input.toLowerCase()) === 0 ||
      driver.firstName.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
      driver.lastName.toLowerCase().indexOf(input.toLowerCase()) > -1);
  }

  filterByCrewMembres() {
    if (!this.model.crewMembers) {
      this.model.crewMembers = [];
      return;
    }
    this.model.crewMembers.forEach(element => {
      if (element.crewType === 1) {
        let index = this.driversForCrew.findIndex(i => i.userNumber === element.userNumber);
        if (index > -1) {
          this.driversForCrew.splice(index, 1);
        }
      }
    });
  }

  filterDriversForTempCrew(input) {

    // this.filterByTempCrewMembres();

    if (typeof input !== 'string') {
      return this.driversForTempCrew;
    }

    return this.driversForTempCrew.filter(driver =>
      driver.userNumber.toLowerCase().indexOf(input.toLowerCase()) === 0 ||
      driver.firstName.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
      driver.lastName.toLowerCase().indexOf(input.toLowerCase()) > -1);
  }

  filterByTempCrewMembres() {
    if (!this.model.crewMembers) {
      this.model.crewMembers = [];
      return;
    }
    this.model.crewMembers.forEach(element => {
      if (element.crewType === 2) {
        let index = this.driversForTempCrew.findIndex(i => i.userNumber === element.userNumber);
        if (index > -1) {
          this.driversForTempCrew.splice(index, 1);
        }
      }
    });
  }

  filterDriversForAccess(input) {
    if (typeof input !== 'string') {
      return this.driversForAccess;
    }

    return this.driversForAccess.filter(driver =>
      driver.userNumber.toLowerCase().indexOf(input.toLowerCase()) === 0 ||
      driver.firstName.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
      driver.lastName.toLowerCase().indexOf(input.toLowerCase()) > -1);
  }

  ngOnInit() {
    let filter = new UserSortableFilter(null);
    filter.Roles = 'BusDriver';
    filter.page = 1;
    filter.pageSize = 50;

    console.log(this.model.allPrimaryBusDrivers);

    this.itemsDataSource = new ItemDataSource(this.model.crewMembers.filter(c => c.crewType === 1), new MatSort());
    this.tempCrewDataSource = new ItemDataSource(this.model.crewMembers.filter(c => c.crewType === 2), new MatSort());
    this.accessDataSource = new AccessDataSource(this.model.oneDayAccesses, new MatSort());

    Observable.forkJoin(this.userService.getItems(filter))
          .subscribe(resp => {
          this.driversForAccess = resp[0].items.map(i => {
            let result = new CrewMember();
            result.userNumber = i.userId;
            result.firstName = i.firstName;
            result.lastName = i.lastName;
            return result;
          });
          this.driversForCrew = this.driversForAccess.slice(0);
          this.driversForTempCrew = this.driversForAccess.slice(0);
          this.filterByCrewMembres();
          this.filterByTempCrewMembres();
          this.crewStateCtrl.updateValueAndValidity();
          this.tempCrewStateCtrl.updateValueAndValidity();
          this.accessStateCtrl.updateValueAndValidity();
        this.dataReady = true;
      });
  }
}

export class CrewMember {
  public crewMemberID;
  public firstName;
  public lastName;
  public userNumber;
  public isPrimary;
  public crewType;
}

export class OneDayAccess {
  public accessID;
  public id;
  public firstName;
  public lastName;
  public userNumber;
  public busID;
  public dateCreated;
}

export class ItemDataSource extends DataSource<CrewMember> {

    constructor(private items: CrewMember[], private sort: MatSort) {
      super();
    }

    connect(collectionViewer: CollectionViewer): Observable<CrewMember[]> {
      return Observable.of(this.items);
    }
    disconnect(collectionViewer: CollectionViewer): void {
    }
}

export class AccessDataSource extends DataSource<OneDayAccess> {

    constructor(private items: OneDayAccess[], private sort: MatSort) {
      super();
    }

    connect(collectionViewer: CollectionViewer): Observable<OneDayAccess[]> {
      return Observable.of(this.items);
    }
    disconnect(collectionViewer: CollectionViewer): void {
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/bus-dialog/bus-dialog.component.ts